(function(){
  'use strict';
  const qs=(s,c=document)=>c.querySelectorAll(s);
  const reveal=()=>{qs('.lsp-reveal').forEach(el=>{const r=el.getBoundingClientRect();if(r.top<window.innerHeight*.9)el.classList.add('is-visible')})};
  const tilt=()=>{qs('[data-lsp-tilt]').forEach(card=>{card.addEventListener('pointermove',e=>{if(innerWidth<900)return;const r=card.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;card.style.transform=`perspective(900px) rotateX(${y*-4}deg) rotateY(${x*6}deg) translateY(-5px)`});card.addEventListener('pointerleave',()=>card.style.transform='')})};
  const parallax=()=>{const h=document.querySelector('.lsp-hero-media img');if(!h||innerWidth<750)return;window.addEventListener('scroll',()=>{const y=window.scrollY;h.style.transform=`scale(1.04) translateY(${y*.05}px)`},{passive:true})};
  document.addEventListener('DOMContentLoaded',()=>{reveal();tilt();parallax();window.addEventListener('scroll',reveal,{passive:true});setTimeout(reveal,300)});
})();

/* LSP Product Gallery — navigation, tilt and 3D focus */
(function(){
  'use strict';
  function initProductGallery(root){
    if(!root || root.dataset.lspReady==='true') return;
    root.dataset.lspReady='true';
    const stage=root;
    const thumbs=Array.from(stage.querySelectorAll('[data-product-thumbnail]'));
    const mediaItems=Array.from(stage.querySelectorAll('[data-product-single-media-flex-wrapper]'));
    const current=stage.querySelector('[data-lsp-current]');
    const prev=stage.querySelector('[data-lsp-prev]');
    const next=stage.querySelector('[data-lsp-next]');
    const threeD=stage.querySelector('[data-lsp-3d]');
    let index=Math.max(0, thumbs.findIndex(t=>t.classList.contains('active-thumb')));
    if(index<0) index=0;
    const pad=n=>String(n).padStart(2,'0');
    const refresh=()=>{ if(current) current.textContent=pad(index+1); };
    const go=(i)=>{
      if(!thumbs.length) return;
      index=(i+thumbs.length)%thumbs.length;
      const t=thumbs[index];
      t.click();
      refresh();
      setTimeout(refresh,120);
    };
    prev&&prev.addEventListener('click',e=>{e.preventDefault();go(index-1)});
    next&&next.addEventListener('click',e=>{e.preventDefault();go(index+1)});
    thumbs.forEach((t,i)=>t.addEventListener('click',()=>{index=i;refresh()}));
    threeD&&threeD.addEventListener('click',()=>{
      const model=thumbs.find(t=>t.querySelector('[data-media-type="model"]'));
      if(model){ model.click(); setTimeout(()=>{ const viewer=stage.querySelector('model-viewer'); if(viewer){ viewer.scrollIntoView({block:'nearest',behavior:'smooth'}); viewer.activateAR?.(); } },250); }
    });
    // Subtle 3D cursor tilt on desktop image/media, disabled for videos and model viewers.
    if(window.matchMedia('(pointer:fine)').matches){
      stage.addEventListener('pointermove',e=>{
        const target=e.target.closest('.product-single__media-flex');
        if(!target || e.target.closest('model-viewer,video,iframe')) return;
        const r=target.getBoundingClientRect();
        const x=(e.clientX-r.left)/r.width-.5;
        const y=(e.clientY-r.top)/r.height-.5;
        target.style.transform=`perspective(1100px) rotateX(${(-y*3.2).toFixed(2)}deg) rotateY(${(x*4.5).toFixed(2)}deg) translateZ(0)`;
      });
      stage.addEventListener('pointerleave',()=>stage.querySelectorAll('.product-single__media-flex').forEach(el=>el.style.transform=''));
    }
    // Keyboard navigation when the gallery is focused.
    stage.tabIndex=0;
    stage.addEventListener('keydown',e=>{
      if(e.key==='ArrowLeft'){e.preventDefault();go(index-1)}
      if(e.key==='ArrowRight'){e.preventDefault();go(index+1)}
    });
    refresh();
  }
  const boot=()=>document.querySelectorAll('[data-lsp-gallery]').forEach(initProductGallery);
  document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
  setTimeout(boot,700);
})();

/* LSP sticky conversion bar */
(function(){
  const boot=()=>{
    const bar=document.querySelector('[data-lsp-sticky-buy]'); if(!bar||bar.dataset.ready==='1') return; bar.dataset.ready='1';
    const add=bar.querySelector('[data-lsp-sticky-add]'); const native=document.querySelector('.product-single__add-to-cart .btn--add-to-cart, .product-form__cart-submit');
    if(!native) return;
    add?.addEventListener('click',()=>native.click());
    const meta=document.querySelector('.product-single__meta--wrapper');
    const io=new IntersectionObserver(entries=>{bar.classList.toggle('is-visible',!entries[0].isIntersecting)},{threshold:.05});
    if(meta) io.observe(meta); else bar.classList.add('is-visible');
  };
  document.addEventListener('DOMContentLoaded',boot); document.addEventListener('shopify:section:load',boot); setTimeout(boot,900);
})();
